// @flow

import * as React from 'react';

import EmojiPicker, {type Props as PickerProps} from './emoji-picker.jsx';

import css from './dialog.css';


export default function EmojiDialog({
  ...props
}: $Diff<PickerProps, {classNames: {...}}>): React.Node {
  return (
    <div className={css.dialog}>
      <EmojiPicker {...props} classNames={css} />
    </div>
  );
}
